export default {
	props: {
		/** 标题 */
		title: {
			type: String
		},

		/** 是否有关闭按钮 */
		has_close_button: {
			type: Boolean,
			default: false
		},
		color:{
			type:String,
			default:'hsl(0, 0%, 37%)'
		}
		
	},


	methods: {
		async on_close_button_click(event) {
			this.$emit('close_button_click', event);
		}
	},
};
